import { ViewportType } from '../../../enums';
export const WSI_PROJECTION_ID = 'wsi';
